import React, { useRef, useState } from "react";
import { Tooltip } from "antd";

type OverflowTooltipProps = {
  text: string;
  className?: string;
  placement?: React.ComponentProps<typeof Tooltip>["placement"];
};

const OverflowTooltip: React.FC<OverflowTooltipProps> = ({
  text,
  className,
  placement,
}) => {
  const ref = useRef<HTMLSpanElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const handleMouseEnter = () => {
    // Re-check on hover in case the container width changed
    if (ref.current) {
      const { scrollWidth, clientWidth } = ref.current;
      setIsOverflowing(scrollWidth > clientWidth);
    }
  };

  return (
    <div className="min-w-0 overflow-hidden">
      <Tooltip
        title={isOverflowing ? text : undefined}
        placement={placement}
        color="#0C4A6E"
      >
        <span
          ref={ref}
          onMouseEnter={handleMouseEnter}
          className={`truncate block ${className ?? ""}`}
        >
          {text}
        </span>
      </Tooltip>
    </div>
  );
};

export default OverflowTooltip;
